module.exports = __webpack_public_path__ + "img/Sainaplaynow.73c4c50d.svg";